import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-park-legend',
    templateUrl: './park-legend.component.html',
    styleUrls: ['./park-legend.component.scss'],
    standalone: false
})
export class ParkLegendComponent implements OnInit {

  colours: any [];

  constructor() {
    this.colours = [
      { priority: 1 },
      { priority: 2 },
      { priority: 3 },
      { priority: 4 },
      { priority: 5 },
      { priority: 6 },
      { priority: 7 },
      { priority: 8 }
    ];
  }

  ngOnInit() { }

}
